import StatisticList from "@/components/StatisticList";
import useTranslations from "@/i18n/useTranslations";

interface Props {
  sideRailStatisticComponent?: {
    title?: string;
    theme?: "light" | "dark";
    items?: {
      percentage: number;
      text: string;
      source: string;
      showItem: boolean;
    }[];
  };
}

const StatisticComponent = ({ sideRailStatisticComponent }: Props) => {
  const t = useTranslations("Common");
  const isLightTheme = sideRailStatisticComponent?.theme === "light";
  const title = sideRailStatisticComponent?.title;
  const monarchItems = sideRailStatisticComponent?.items;
  const localizedDefaults = [
    {
      percentage: 84,
      text: t("statProfessionalGrowth"),
      source: t("sourceLabel", { source: t("certificateSurveySource") }),
      showItem: true,
    },
    {
      percentage: 57,
      text: t("statResumeStrength"),
      source: t("sourceLabel", { source: t("certificateSurveySource") }),
      showItem: true,
    },
  ];
  const detailItems =
    monarchItems !== undefined && monarchItems?.length > 0
      ? monarchItems
      : localizedDefaults;

  const resolvedTitle =
    !title || title === "See real results" ? t("seeRealResults") : title;

  return (
    <div
      className={`p-4 rounded-xl ${isLightTheme ? "bg-white" : "bg-[#00262B]"}`}
    >
      <StatisticList
        title={resolvedTitle}
        details={detailItems}
        titleFontClass={`!text-2xl ${isLightTheme && "!text-primary-500"}`}
        descriptionFontClass={`!gap-0.5 ${isLightTheme && "!text-primary-500"}`}
        percentageFontClass={`${isLightTheme && "!text-primary-500"}`}
        sourceFontClass={`${isLightTheme && "!text-primary-500"}`}
        containerClass="!gap-4"
      />
    </div>
  );
};
export default StatisticComponent;
